import { FC } from 'react';
import { Tooltip } from '@mui/material';
import { truncateText } from '@vs-online-only-app/ui';

type Props = {
  name: string;
  truncateLimit?: number;
};

export const ParticipantName: FC<Props> = ({ name, truncateLimit = 16 }) => {
  const truncatedName = truncateText(name, truncateLimit);
  const isTextTruncated = name !== truncatedName;

  return (
    <Tooltip
      title={isTextTruncated ? name : ''}
      arrow
      PopperProps={{ disablePortal: true }}
      placement="top"
    >
      <span>{truncatedName}</span>
    </Tooltip>
  );
};
